import { getDateTimeFromUtcToLocal } from '@shared/entity';
import { CreateVisitType, VisitDetail } from '../../../../entity';

export const validateDateFormat =
  () =>
  (value: Date | undefined, _formValues: CreateVisitType): string | boolean =>
    !(value instanceof Date) ? 'addVisitForm.chooseDateTime' : true;

export const validateIsTakenDate =
  (visits: VisitDetail[]) =>
  (value: Date | undefined, _formValues: CreateVisitType): string | boolean => {
    const isTaken =
      value &&
      visits.some(
        visit =>
          getDateTimeFromUtcToLocal(visit.visit.dateFrom) === getDateTimeFromUtcToLocal(value),
      );

    return isTaken ? 'addVisitForm.visitTimeAlreadyBooked' : true;
  };
